import PopupActions from '../../actions/PopupActions';
import UserStore from '../../stores/UserStore';
import DD from '../form/dropdown/DD.react';
import DOB from '../form/DOB.react';
import PageRow from '../form/layout/PageRow.react';
import Input from '../form/input/Input.react';
import { endPoints as GuestEndPoints } from '../../constants/GuestListConstants';
import AjaxPromises from '../../utils/AjaxPromises';
import GuestStore from '../../stores/GuestStore';
import GuestActions from '../../actions/GuestActions';

class SelectCollector extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            collectors: [],
            selectedCollectorId: '-1',
            caregiverId : '',
            caregiverName: '',
            caregiverLastName: '',
            caregiverRelationship: '',
            selectState: true,
            isEditingCollector: false,
            collectorToEdit: null,
            caregiverDob: '',
            caregiverPhone: '',
            caregiverEmail: '', 
            caregiverNotes: '',
            caregiverIndex: '',
        };

        this.save = this.save.bind(this);
        this.loadCollectors = this.loadCollectors.bind(this);
        this.isValid = this.isValid.bind(this);
        this.filterColloectors = this.filterColloectors.bind(this);
        this.isCollectorEditable = this.isCollectorEditable.bind(this);
    }


    componentDidMount() {
        this.loadCollectors();
    }

    componentWillUnmount() {
        GuestStore.showCollector(false);
    }

    filterColloectors(toAdd) {
        let collectors = [];
        for(let i = 0; i < toAdd.length; i++) {
            if((!!toAdd[i] && !!toAdd[i].CaregiverMJStateIdNo && !!(toAdd[i].CaregiverRelationship || toAdd[i].Notes)) &&
            //filter dups
                collectors.findIndex((x) => {
                    return x.CaregiverMJStateIdNo === toAdd[i].CaregiverMJStateIdNo && 
                    (toAdd[i].CaregiverRelationship || toAdd[i].Notes) === (x.CaregiverRelationship || x.Notes);
                }) <= -1) {
                    collectors.push(toAdd[i]);
            }
        }

        return collectors
    }

    isValid() {
        return this.state.selectedCollectorId === '-1' || (
            !!this.state.caregiverId &&
            !!this.state.caregiverRelationship &&
            !!this.state.caregiverName &&
            !!this.state.caregiverLastName &&
            (!this.state.caregiverDob || !!moment(this.state.caregiverDob).isValid())
        )
    }

    loadCollectors() {

        if(!this.props.guest) {
            return;
        }

        AjaxPromises.POST(GuestEndPoints.GET_COLLECTORS, UserStore.getApiData({
            CustomerId : this.props.guest.Guest_id
        })).then(res => {
            if (res.Result) {
                const {
                    name,
                    CaregiverMJStateIdNo,
                    CaregiverRelationship,
                    Notes,
                    DOB,
                    Email,
                    Phone,
                    CaregiverIndex,
                } = res.Data[0];

                const names = name && name.split(' ');

                this.setState({
                    collectors : this.filterColloectors(res.Data),
                    selectedCollectorId: res.Data.length > 0 && !!CaregiverMJStateIdNo ? CaregiverMJStateIdNo : '-1', 
                    caregiverId : CaregiverMJStateIdNo,
                    caregiverName: names && names.length > 1 ? names[0] : '',
                    caregiverLastName: names && names.length > 1 ? names[1] : '',
                    //Sometimes we store the relationship in notes for non-primary caregivers
                    caregiverRelationship: CaregiverRelationship || Notes, 
                    caregiverDob: moment(DOB).isValid() ? moment(DOB).format('MM/DD/YYYY') : '',
                    caregiverNotes: Notes,
                    caregiverEmail: Email,
                    caregiverPhone: Phone,
                    caregiverIndex: CaregiverIndex
                });
            }
        });
    }

    save() {
        const {
            isEditingCollector,
            collectorToEdit,
            caregiverId,
            caregiverName,
            caregiverLastName,
            caregiverRelationship,
            caregiverDob,
            caregiverEmail,
            caregiverNotes,
            caregiverPhone,
            caregiverIndex,
        } = this.state;

        const { Guest_id } = this.props.guest

        if (isEditingCollector && collectorToEdit) {
            return AjaxPromises.POST(GuestEndPoints.EDIT_COLLECTOR, UserStore.getApiData({
                CustomerId : Guest_id,
                CaregiverId: caregiverId,
                CaregiverName: `${caregiverName} ${caregiverLastName}`,
                CaregiverRelationship: caregiverRelationship,
                CaregiverDob: moment(caregiverDob).isValid() ? moment(caregiverDob).format('MM/DD/YYYY') : null,
                CaregiverPhone: caregiverPhone,
                CaregiverEmail: caregiverEmail,
                caregiverNotes: caregiverNotes,
                caregiverIndex: caregiverIndex,
                InitialCaregiverId: collectorToEdit.caregiverId,
                InitialCaregiverName: `${collectorToEdit.caregiverName} ${collectorToEdit.caregiverLastName}`,
                InitialCaregiverRelationship: collectorToEdit.caregiverRelationship,
                InitialCaregiverDob: moment(collectorToEdit.caregiverDob).isValid() ? collectorToEdit.caregiverDob : null,
                InitialCaregiverPhone: collectorToEdit.caregiverPhone,
                InitialCaregiverEmail: collectorToEdit.caregiverEmail,
                InitialCaregiverNotes: collectorToEdit.caregiverNotes,
                InitialCaregiverIndex: collectorToEdit.caregiverIndex,
            })).then(res => {
                PopupActions.close();
                GuestActions.loadFullGuest(Guest_id);
            });
        }
        return AjaxPromises.POST(GuestEndPoints.SELECT_COLLECTOR, UserStore.getApiData({
            CustomerId : Guest_id,
            CaregiverId: caregiverId,
            CaregiverName: `${caregiverName} ${caregiverLastName}`,
            CaregiverRelationship: caregiverRelationship,
            CaregiverDob: moment(caregiverDob).isValid() ? moment(caregiverDob).format('MM/DD/YYYY') : null,
            CaregiverPhone: caregiverPhone,
            CaregiverEmail: caregiverEmail,
            caregiverNotes: caregiverNotes,
            caregiverIndex: caregiverIndex,
        })).then(res => {
            PopupActions.close();
            GuestActions.loadFullGuest(Guest_id);
        });
    }

    isCollectorEditable() {
        return this.state.selectedCollectorId !== '-1' && this.state.selectedCollectorId !== '';
    }

    render() {

        var collectors = [
            { title : '--None--', option : '-1'},
        ];

        for(var i = 0; i < this.state.collectors.length; i++) {
            const {
                name,
                CaregiverMJStateIdNo,
            } = this.state.collectors[i];

            collectors.push({
                title: name ? `${name} - ${CaregiverMJStateIdNo}` : CaregiverMJStateIdNo,
                option: CaregiverMJStateIdNo,
            });
        }
        
        return (
            <div className='popup popup__transparent'>

                <div className='popup__content sidebar-notes__edit'>

                    <div className='popup-header'>
                        Select Collector
                    </div>
                    <div className='popup-content'>
                    { this.state.selectState &&
                    <div style={{margin: 10}}>
                        <h5>Collector</h5>
                        <DD
                            value={this.state.selectedCollectorId}
                            onChange={selectedCollectorId => { 
                                let name, lastName, id, relation, dob, email, phone, notes, index;
                                if(selectedCollectorId === '-1') {
                                    name = '';
                                    lastName = '';
                                    id = '';
                                    relation = '';
                                    dob = '';
                                    email = '';
                                    phone = '';
                                    notes = '';
                                    index = '';
                                } else {
                                    let collector = _.find(this.state.collectors, x => x.CaregiverMJStateIdNo === selectedCollectorId);
                                    const collectorNames = collector.name.split(' ')
                                    name = collectorNames && collectorNames.length > 1 ? collectorNames[0] : '';
                                    lastName = collectorNames && collectorNames.length > 1 ? collectorNames[1] : '';
                                    id = collector.CaregiverMJStateIdNo;
                                    relation = collector.CaregiverRelationship || collector.Notes; //Sometimes we store the relationship in notes for non-primary caregivers
                                    dob = collector.DOB;
                                    email = collector.Email;
                                    phone = collector.Phone;
                                    notes = collector.Notes;
                                    index = collector.CaregiverIndex;
                                }
                                
                                
                                this.setState({ 
                                    selectedCollectorId,
                                    caregiverId : id,
                                    caregiverName: name,
                                    caregiverLastName: lastName,
                                    caregiverRelationship: relation, 
                                    caregiverDob: dob,
                                    caregiverEmail: email,
                                    caregiverPhone: phone,
                                    caregiverNotes: notes,
                                    caregiverIndex: index,
                                }); }}
                            options={collectors} />
                       </div>
                    }

                    { !this.state.selectState &&
                        <div style={{margin: 10}}>
                        <h5>{this.state.isEditingCollector && this.state.collectorToEdit ? 'Edit Collector' : 'Add New Collector'}</h5>
                            <PageRow title='Collector First Name'>
                                <Input
                                    value={this.state.caregiverName}
                                    onChange={caregiverName => { this.setState({ caregiverName }); }}
                                    placeholder='First Name' />
                            </PageRow>
                            <PageRow title='Collector Last Name'>
                                <Input
                                    value={this.state.caregiverLastName}
                                    onChange={caregiverLastName => { this.setState({ caregiverLastName }); }}
                                    placeholder='Last Name' />
                            </PageRow>
                            <PageRow title='Collector ID*'>
                                <Input
                                    value={this.state.caregiverId}
                                    onChange={caregiverId => { this.setState({ caregiverId }); }}
                                    placeholder='ID Number' />
                            </PageRow>
                            <PageRow title='Collector DOB'>
                                <DOB
                                    className="input"
                                    field='caregiverDob'
                                    value={moment(this.state.caregiverDob).isValid() ? moment(this.state.caregiverDob).format('MM/DD/YYYY') : null}
                                    onChange={(field, date) => this.setState({ [field]: date })} />
                            </PageRow>
                            <PageRow title='Collector Relationship*'>
                                <DD
                                    required
                                    value={this.state.caregiverRelationship}
                                    onChange={caregiverRelationship => { this.setState({ caregiverRelationship }); }}
                                    options={
                                    [
                                        { title: '-', option: ''},
                                        { title: 'Parent/Legal Guardian', option: 'PLG' },
                                        { title: 'Caregiver', option: 'CAREGIVER' },
                                    ]
                                    } />
                            </PageRow>
                        </div>
                    }

                    <button
                    className='btn-green'
                    style={{position: 'absolute', bottom: 10, left: 10}}
                    onClick={() => {
                        this.setState({
                            selectState: !this.state.selectState,
                            caregiverId: '',
                            caregiverName: '',
                            caregiverLastName: '',
                            caregiverRelationship: '',
                            caregiverDob: '',
                            caregiverEmail: '',
                            caregiverPhone: '',
                            caregiverNotes: '',
                            caregiverIndex: '',
                            selectedCollectorId: '-1',
                            isEditingCollector: false,
                            collectorToEdit: null,
                        });
                    }}
                    >
                        { this.state.selectState ? 'Add New Collector' : 'Select Existing' }
                    </button>

                    <button
                    className={`btn-green ${this.isCollectorEditable() ? '' : 'btn-green__disabled'}`}
                    style={{position: 'absolute', bottom: 10, left: 190.69, display: !this.state.selectState && 'none'}}
                    onClick={() => {
                        this.setState({
                            selectState: !this.state.selectState,
                            isEditingCollector: true,
                            collectorToEdit: {
                                caregiverId: this.state.caregiverId,
                                caregiverName: this.state.caregiverName,
                                caregiverLastName: this.state.caregiverLastName,
                                caregiverRelationship: this.state.caregiverRelationship,
                                caregiverDob: this.state.caregiverDob,
                                caregiverEmail: this.state.caregiverEmail,
                                caregiverPhone: this.state.caregiverPhone,
                                caregiverNotes: this.state.caregiverNotes,
                                caregiverIndex: this.state.caregiverIndex,
                            }
                        });
                    }}
                    disabled={!this.isCollectorEditable()}
                    >
                        Edit Collector
                    </button>
                       
                    <button
                        className={`btn-green ${this.isValid() ? '' : 'btn-green__disabled'}`}
                        style={{position: 'absolute', bottom: 10, right: 10}}
                        onClick={this.save}
                        disabled={!this.isValid()}
                        >

                        Continue
                    </button>
                       
                    </div>
                </div>
            </div>
        );
    }
}

export default SelectCollector;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/SelectCollector.react.jsx